import { http } from '@/shared/api/axios';
import type {
  CredentialMapping,
  EligibleRequirement,
  CredentialVerificationStatus,
  AppliesToEmployeeType,
  ComplianceMissingItem,
} from '../model/types';

export interface VerifyMappingResponse {
  mapping: CredentialMapping;
  compliance: { isCompliant: boolean; missing: ComplianceMissingItem[] };
}

export const credentialMappingApi = {
  listMine: async (): Promise<CredentialMapping[]> => {
    const { data } = await http.get<CredentialMapping[]>('/v1/me/credential-mappings');
    return data;
  },
  listMyEligibleRequirements: async (): Promise<EligibleRequirement[]> => {
    const { data } = await http.get<EligibleRequirement[]>(
      '/v1/me/credential-mappings/eligible-requirements'
    );
    return data;
  },
  createMine: async (
    employeeCredentialId: number,
    requiredCredentialId: number
  ): Promise<CredentialMapping> => {
    const { data } = await http.post<CredentialMapping>(
      '/v1/me/credential-mappings',
      { employeeCredentialId, requiredCredentialId },
      { _skipErrorToast: true } as never
    );
    return data;
  },
  deleteMine: async (mappingId: number): Promise<void> => {
    await http.delete(`/v1/me/credential-mappings/${mappingId}`);
  },

  list: async (filters?: {
    userId?: number;
    requiredCredentialId?: number;
    verificationStatus?: CredentialVerificationStatus;
    appliesTo?: AppliesToEmployeeType;
  }): Promise<CredentialMapping[]> => {
    const { data } = await http.get<CredentialMapping[]>('/v1/credential-mappings', {
      params: filters,
    });
    return data;
  },
  listForEmployee: async (employeeId: number): Promise<CredentialMapping[]> => {
    const { data } = await http.get<CredentialMapping[]>(
      `/v1/employees/${employeeId}/credential-mappings`
    );
    return data;
  },
  verify: async (mappingId: number): Promise<VerifyMappingResponse> => {
    const { data } = await http.post<VerifyMappingResponse>(
      `/v1/credential-mappings/${mappingId}/verify`
    );
    return data;
  },
  reject: async (mappingId: number, reason: string): Promise<CredentialMapping> => {
    const { data } = await http.post<CredentialMapping>(
      `/v1/credential-mappings/${mappingId}/reject`,
      { rejectionReason: reason }
    );
    return data;
  },
};
